import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowLeft, Sparkles } from 'lucide-react';
import SEO from '../components/SEO';

export default function ThankYou() {
  return (
    <>
      <SEO
        title="Vi har modtaget din besked | Autentisk thai mad i Skibby | Bestil take-away eller en foodtruck"
        description="Tak for din henvendelse, vi kontakter dig hurtigst muligt. Gå tilbage til forsiden"
      />

      <section className="min-h-screen flex items-center justify-center pt-24 pb-16 bg-brand-cream text-brand-dark">
        <div className="max-w-xl mx-auto px-6 text-center flex flex-col items-center gap-6 bg-white p-10 sm:p-12 rounded-3xl border border-gray-100 shadow-xl">
          <div className="w-16 h-16 bg-emerald-500/10 rounded-full flex items-center justify-center text-emerald-500 animate-bounce">
            <CheckCircle2 className="w-10 h-10" />
          </div>

          <div className="flex flex-col gap-2">
            <div className="inline-flex items-center justify-center gap-1.5 text-brand-primary font-semibold uppercase tracking-wider text-xs">
              <Sparkles className="w-4 h-4" />
              Modtaget!
            </div>
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-brand-dark leading-tight">
              Vi har modtaget din besked
            </h1>
          </div>

          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
            Tak for din henvendelse, vi kontakter dig hurtigst muligt.
          </p>

          <div className="w-full border-t border-gray-100 pt-6 mt-2">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-brand-dark hover:bg-brand-dark/90 text-white font-semibold px-6 py-3 rounded-full transition-all shadow-md w-full sm:w-auto"
            >
              <ArrowLeft className="w-4 h-4" />
              Gå tilbage til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
